export default "__VITE_ASSET__BOijx$gV__"